import innovationFields from './innovation-fields'
import innovationProjects from './innovation-projects'
import marketAnalysis from './market-analysis'
import readiness from './readiness'
import recommendations from './recommendations'

export default {
    innovationFields,
    innovationProjects,
    marketAnalysis,
    readiness,
    recommendations
}
